<template>
    <div class="payModalWrap">
        <div class="mask" @click="closeModal"></div>
        <div class="payModalBox">
            <div class="title">填写付款信息</div>
            <div class="modalContent">
                <div class="oneArea firstArea">
                    <!-- {{infoObj}} -->
                    <!-- <div class="oneline" v-if="isLiquidation"><span class="mylabel">清算账单订单号：</span><span class="text">{{infoObj.orderId}}</span></div> -->
                    <div class="oneline" v-if="!isLiquidation"><span class="mylabel">下单订单号：</span><span class="text">{{infoObj.orderId}}</span></div>
                    <div class="oneline"><span class="mylabel">商品款号：</span><span class="text">{{infoObj.itemId}}</span></div>
                </div>
                <div class="oneArea twoArea">
                    <!-- 清算付款显示的 -->
                    <div v-if="isLiquidation">
                        <div class="oneline"><span class="mylabel">总共可核销数量/下单数量：</span><span class="text">{{infoObj.totalEstablish}}件</span></div>
                        <div class="oneline"><span class="mylabel">累计已核销数量：</span><span class="text">{{infoObj.haveEstablishTotal}}件</span></div>
                        <div class="oneline"><span class="mylabel">清算自动核销数量：</span><span class="text">{{infoObj.autoEstablish}}件</span></div>
                        <div class="oneline"><span class="mylabel">退货数量：</span><span class="text">{{infoObj.returnNumber}}件</span></div>
                        
                        
                        <div class="oneline"><span class="mylabel">退后前待支付金额：</span><span class="text">{{infoObj.historyLeftMoney }}元</span></div>
                        <div class="oneline"><span class="mylabel">退货后待支付金额：</span><span class="text">{{infoObj.nowLeftMoney }}元</span></div>
                        <div class="oneline"><span class="mylabel">总共待支付：</span><span class="text">{{infoObj.allLeftMoney }}元</span></div>
                        <div class="oneline"><span class="mylabel">平台已确认支付金额：</span><span class="text">{{infoObj.order_pay_amount||0}}元</span></div>
                        <div class="oneline"><span class="mylabel">平台未确认支付金额：</span><span class="text">{{infoObj.amountToBeConfirmed}}元</span></div>
                        <div class="oneline"><span class="mylabel">清算剩余需支付金额：</span><span class="text red">{{infoObj.rest_pay_amount_subConfirm}}元</span></div>
                        
                        <!-- <div class="oneline"><span class="mylabel">清算剩余需支付金额-ces：</span><span class="text red">{{infoObj.chargeBalance}}元</span></div>    
                        <div class="oneline small" ><span class="mylabel">
                        （其中包含已支付未确认金额：{{infoObj.amountToBeConfirmed}}元,</span>
                            再支付{{infoObj.chargeBalance-infoObj.amountToBeConfirmed}}元)</span>
                        </div> -->
                    </div>
                    <!-- 下单的付款 不是清算 -->
                    <div v-if="!isLiquidation">
                        <div class="oneline"><span class="mylabel label1">本下单订单总下单数量：</span><span class="text">{{infoObj.totalEstablish}}件</span></div>
                        <div class="oneline"><span class="mylabel label1">本下单订单剩余未核销数量：</span><span class="text">{{infoObj.leftEstablishTotal}}件</span></div>
                        <div class="oneline"><span class="mylabel label1">本下单订单已核销数量：</span><span class="text">{{infoObj.haveEstablishTotal}}件</span></div>
                        <div class="oneline"><span class="mylabel label2">本期账单总金额：</span><span class="text">{{infoObj.order_bill_amount }}元</span></div>
                        <div class="oneline"><span class="mylabel label2">本期账单累计成功支付：</span><span class="text">{{infoObj.order_pay_amount||0}}元</span></div>
                        <div class="oneline"><span class="mylabel label2">本期账单提交且未被平台确认金额：</span><span class="text">{{infoObj.amountToBeConfirmed}}元</span></div>
                        <div class="oneline"><span class="mylabel label2">本期账单您需再提交支付金额：</span><span class="text red">{{infoObj.rest_pay_amount_subConfirm}}元</span></div>
                        
                        
                        
                       <!-- <div class="oneline"><span class="mylabel">本期账单剩余需支付金额：</span><span class="text red">{{infoObj.chargeBalance}}元</span></div>
                        <div class="oneline small" ><span class="mylabel">
                        （其中包含已支付未确认金额：{{infoObj.amountToBeConfirmed}}元,</span>
                            再支付{{infoObj.chargeBalance-infoObj.amountToBeConfirmed}}元)</span>
                        </div> -->
                    </div>
                    
                    <div class="oneline"><span class="mylabel"> <i class="red">*</i> 本次实际支付金额：</span><input type="text"
                            placeholder="请输入金额" v-model="number">元</div>
                </div>
                <div class="oneArea">
                    <div class="oneline">
                        <el-upload v-if="imgsArr.length<5"
                          class="upload_mock_Btn"
                          :action="uploadFileApi"
                          name="files"
                          drag
                          :data="uploadData"
                          :show-file-list="false"
                          :on-success="(res, file) => {return handleImgSuccess(res, file)}"
                          :before-upload="beforeImgUpload"
                          accept="image/*">
                          <div class="el-upload__text"> <em>上传凭证</em> 或拖拽图片到此处</div>
                        </el-upload>
                        <span style="margin-left: 10px;font-size: 12px;color:#aaa;">拖拽图片到此处或点击上传；最多上传5张； 每张图片不超过5M</span>
                    </div>
                    <div class="oneline">
                       <!-- <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" :on-preview="handlePreview"
                            :on-remove="handleRemove" :file-list="fileList" list-type="picture">
                            <el-button size="small" plain> <i class="el-icon-upload2"></i> 上传支付凭证</el-button>
                            <span slot="tip" class="el-upload__tip" style="margin-left: 10px;">最多上传5张</span>
                        </el-upload> -->
                        <div class="oneImgBox" v-for="(list,index) in imgsArr">
                            <el-image
                              class="uploadImgAvatar"
                              :src="list.wei_url"
                              fit="contain"
                              :preview-src-list="[list]"
                            ></el-image>
                            <div class="imgDeleteBox"  @click="deleteImg(index)"><i class="el-icon-delete" style="margin-right:5px"></i>删除</div>
                        </div>
                        
                
                    </div>
                </div>
                <div class="oneArea">
                    <div class="oneline">
                        <span class="mylabel">付款说明：</span>
                        <br>
                        <textarea name="" id="" cols="48" rows="5" placeholder="请输入说明,最多300字" v-model="memo"></textarea>
                    </div>
                </div>
            </div>
            
            <div class="footer">
                <button class="closeBtn btn" @click="closeModal">取消</button>
                <button class="submitBtn btn" @click="submitClick">确定</button>
            </div>
        </div>

    </div>
</template>

<script>
    import { uploadFileApi } from '../api/public'
    import {   mapState} from 'vuex'
    import {saveOrderPayment,saveOrderPaymentByliquidate} from '../api/dealer'
    import {getTwoPointerNumber,computeSub} from '../utils/tools.js'
    
    export default {
        name: 'hexiao',
        props: ["info","isLiquidation"],
        computed: {
            ...mapState({
                userId: state => state.user.userId
            }),
            infoObj() {
                this.info.allLeftMoney=getTwoPointerNumber(this.info.allLeftMoney)
                return this.info
            }
        },
        data() {
            return {
                imgsArr:[],//图片数组
                number: "",
                memo:'',
                
                // 上传图片api
                uploadFileApi: '',
                uploadData: {
                  imageType: 12201,
                  imageUserId: ''
                },
                
            }
        },
        watch: {},
        methods: {
            deleteImg(index){
              this.imgsArr.splice(index,1)  
            },
            // 图片上传成功
            handleImgSuccess(res, file) {
              console.log(res, file)
              if (res.errorCode == 200) {
                  let buffer={
                      wei_url:URL.createObjectURL(file.raw),
                      imageFiles:res.data.imageFiles,
                      imgId: res.data.imgId
                  }
                  this.imgsArr.push(buffer)
                  console.log(this.imgsArr)
                // this.ruleForm['imgItem_' + NUM] = res.data
                // this.ruleForm['imageUrl_' + NUM] = URL.createObjectURL(file.raw);
                // if (NUM == '1') {
                //   this.$refs['ruleForm'].clearValidate('imageUrl_1')
                // }
                
              }
            },
            beforeImgUpload(file) {
              console.log(file)
            
              const isImg = /^image\/*/.test(file.type)
              const isLt5M = file.size / 1024 / 1024 < 5
              if (!isImg) {
                this.$message.error('只能上传图片!');
              }
              if (!isLt5M) {
                this.$message.error('上传图片大小不能超过 5MB!');
              }
              return isImg && isLt5M;
            },
            // handleRemove(file, fileList) {
            //     console.log(file, fileList);
            // },
            // handlePreview(file) {
            //     console.log(file);
            // },
            closeModal() {
                this.number = ''
                this.$emit("close")
            },
            closeModalAndSuccess() {
                this.number = ''
                this.$emit("success")
                this.
                initModal()
            },
            initModal(){
                this.imgsArr=[]//图片数组
                this.number=""
                this.memo=''
            },
            submitClick() {
                let _this = this
                let imgNewArr=this.imgsArr.map(function(item,index){
                    let buffer={
                        imageFiles: item.imageFiles,
                        imgId:item.imgId
                    }
                    return buffer
                })
                if (!this.number) {
                    this.$message.error('金额不能为空')
                } else if (this.number <= 0) {
                    this.$message.error('请输入大于0的金额')
                } else if (isNaN(this.number)) {
                    this.$message.error('金额只能为数字')
                }
                // else if (Number(this.number)  > Number(this.infoObj.chargeBalance-this.infoObj.amountToBeConfirmed) ) {
                //     this.$message.error('金额不能超过待支付总金额')
                // }
                else {
                    if(!this.isLiquidation){
                        let arg = {
                            supplierUserId: _this.infoObj.supplierUserId,
                            dealerUserId: _this.userId,
                            itemId: _this.infoObj.itemId,
                            orderPurchaseNumber: _this.infoObj.orderId,                  
                            imgJson:JSON.stringify(imgNewArr),
                            billOrderId:_this.infoObj.billOrderId,
                            orderPaymentAmount: _this.number,
                            orderPaymentMemo:_this.memo,
                        }
                        console.log(arg)
                        saveOrderPayment(arg).then(res => {
                            console.log(res)
                            if (res.errorCode == 200) {
                                this.$message.success("提交支付凭证成功")
                                _this.closeModalAndSuccess()
                            } else {
                                this.$message.error(res.errorMsg)
                            }
                        })
                    }else{
                        // alert("这里是清算付款")
                        console.log("这里是清算付款")
                        let arg = {
                            liquidateOrderId:_this.infoObj.liquidateOrderId,
                            supplierUserId: _this.infoObj.supplierUserId,
                            dealerUserId: _this.userId,
                            itemId: _this.infoObj.itemId,
                            // orderPurchaseNumber: _this.infoObj.orderId, 
                            imgJson:JSON.stringify(imgNewArr),
                            orderPaymentAmount: _this.number,
                            orderPaymentMemo:_this.memo,
                            billId:_this.infoObj.billId
                            
                            // liquidateOrderId:_this.infoObj.liquidateOrderId,
                            // supplierUserId: _this.infoObj.supplierUserId,
                            // dealerUserId: _this.userId,
                            // itemId: _this.infoObj.itemId,
                            // imgJson:JSON.stringify(imgNewArr),
                            // orderLiquidateAmount: _this.number,
                            // orderLiquidateMemo:_this.memo,
                            // liquidateBillOrderId: _this.infoObj.orderId, 
                        }
                        console.log(arg)
                        saveOrderPaymentByliquidate(arg).then(res => {
                            console.log(res)
                            if (res.errorCode == 200) {
                                this.$message.success("提交支付凭证成功")
                                _this.closeModalAndSuccess()
                            } else {
                                this.$message.error(res.errorMsg)
                            }
                        })
                    }
                    
                }
            }
        },
        created() {
          this.uploadFileApi = uploadFileApi
          this.uploadData.imageUserId = this.userId  
        },
        mounted() {

        }
    }
</script>

<style scoped lang="scss">
    textarea{border-radius: 4px;border:1px solid #C4C6CF;padding:6px 9px ;margin-top:8px;}
    .payModalWrap {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 100;
        
        .oneImgBox:hover{border-color: red;}
        .oneImgBox{
            display: inline-block; border:1px dashed #ccc;margin-right: 15px;position: relative;
            
            .uploadImgAvatar{
               width: 120px;height: 120px;
               img{max-width: 100%;max-height: 100%;}
            }
            .imgDeleteBox{
                position: absolute;cursor: pointer;
                width: 100%; text-align: center;background: rgba(0,0,0,0.3);color:#ddd;bottom:0px;font-size: 12px;padding:5px 0;
            }
            .imgDeleteBox:hover{color:red;background: rgba(0,0,0,0.7);}
        }

        .mask {
            background: rgba(0, 0, 0, 0.5);
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
        }
        .modalContent{
            padding:0 24px; 
        }
        .payModalBox {
            position: fixed;
            z-index: 1000;
            left: 25%;
            top: 3%;
            max-height: 95%;
            width: 50%;
            min-width: 460px;
            overflow: auto;
            border: 1px solid #eee;
            border-radius: 4px;
            background: #fff;
            border-radius: 2px;

            input {
                border: 1px solid #ddd;
                border-radius: 4px;
                padding: 8px;
            }

            .title {
                font-size: 18px;
                padding: 19px 25px;
                border-bottom: 1px solid #eee;
            }

            .oneArea {
                margin: 20px 0;
            }

            .oneline {
                margin: 8px 0;
                color:#000;opacity: 0.85;font-size: 16px;
                
            }
            .oneline.small{font-size: 12px;}

            .firstArea {
                .oneline {
                }
            }
            .twoArea{
                background: #f9f9f9;padding:16px 24px;
                .oneline {
                    margin: 4px 0; color:#333;opacity: 1;
                }
            }

            .mylabel {}
            // .mylabel.label1{display: inline-block;width: 260px;}
            // .mylabel.label2{display: inline-block;width: 260px;}

            .text {}

            .footer {
                text-align: right;
                border-top: 1px solid #eee;
                padding: 14px 25px;

                .btn {
                    padding: 5px 16px;
                    background: #fff;
                    font-size: 12px;
                    border-radius: 4px;
                }

                .closeBtn {
                    margin-right: 10px;
                    border: 1px solid #D9D9D9;
                }

                .submitBtn {
                    background: #F81D22;
                    color: #fff;
                    border: 0;
                }
            }
        }
    }
    
</style>
